export const landingConfig = {
  appName: 'StatementSync',
  brandName: 'BPA Solutions',
  tagline: 'Turn bank statement PDFs into clean Excel and CSV data.',
  shortDescription: 'StatementSync extracts, reviews, cleans and exports transaction data from readable bank statement PDFs without the repetitive work of manual retyping.',
  contactEmail: 'support@bpasolutions.au',
  supportEmail: 'support@bpasolutions.au',
  contactPhone: '+61 425 228 778',
  websiteUrl: 'https://www.bpasolutions.au',
  existingUserAppUrl: 'https://app.bpasolutions.au/StatementSync-pro',
  freeTrialUrl: 'https://app.bpasolutions.au/StatementSync-pro',
  legalLinks: {
    terms: 'https://legal.bpasolutions.au/#/legal/version/acm41rqs0237jzb',
    privacy: 'https://legal.bpasolutions.au/#/legal/version/lwgdwsb2ts0nsyb',
    refunds: 'https://legal.bpasolutions.au/#/legal/version/144l0hqmxa3rvtc',
  },
  checkoutLinks: {
    monthly: 'https://bpasolutions.lemonsqueezy.com/checkout/buy/971a578d-46a7-40b9-8fc4-70d4b508bd8f',
    annual: 'https://bpasolutions.lemonsqueezy.com/checkout/buy/4142a1b4-9e46-46fb-bcd6-2515232db5e5',
    lifetime: 'https://bpasolutions.lemonsqueezy.com/checkout/buy/ba47a6e4-6a4e-4bfa-8d0e-85deee1e0346',
  },
  pricingPlans: [
    {
      id: 'monthly',
      name: 'Monthly Plan',
      price: 'A$24.99',
      period: '/ month',
      deviceAccess: '1 Device Access',
      linkType: 'monthly',
    },
    {
      id: 'annual',
      name: 'Annual Plan',
      price: 'A$147.99',
      period: '/ year',
      deviceAccess: '2 Devices',
      linkType: 'annual',
    },
    {
      id: 'lifetime',
      name: 'Lifetime Plan',
      price: 'A$187.99',
      period: 'one-time',
      deviceAccess: '3 Devices Access',
      linkType: 'lifetime',
    },
  ],
  targetAudiences: [
    'Small business owners',
    'Bookkeepers',
    'Accountants',
    'Property investors',
    'Admin teams',
    'Individuals working with bank statement records',
  ],
  faqItems: [
    {
      question: 'What does StatementSync do?',
      answer: 'StatementSync converts readable bank statement PDFs into structured transaction data, lets you review and edit the extracted rows, and exports the result to Excel or CSV.',
    },
    {
      question: 'What type of bank statement PDF works best?',
      answer: 'StatementSync is designed for readable PDFs that contain embedded text. Image-only or heavily scanned statements may need OCR before conversion, and unusual statement layouts can require additional review.',
    },
    {
      question: 'Is my bank statement data uploaded or transmitted anywhere?',
      answer: 'StatementSync is designed so your bank statement information is not transmitted anywhere during the conversion workflow. The privacy-focused workflow keeps sensitive statement data under your control.',
    },
    {
      question: 'How quickly can StatementSync convert a bank statement?',
      answer: 'For readable supported statements, the conversion workflow is designed to complete in under 30 seconds in typical use. Processing time can vary with the PDF and device.',
    },
    {
      question: 'Can StatementSync handle multi-line transaction descriptions?',
      answer: 'Yes. StatementSync is designed to combine transaction descriptions that span multiple PDF lines into cleaner rows where the statement structure allows it.',
    },
    {
      question: 'Can I review and correct transactions before exporting?',
      answer: 'Yes. The extracted rows are shown in an editable review grid so you can inspect and correct the data before downloading the final file.',
    },
    {
      question: 'Which export formats does StatementSync support?',
      answer: 'StatementSync exports cleaned transaction data to Excel and CSV so the result can be filtered, analysed, reconciled or used in downstream bookkeeping workflows.',
    },
    {
      question: 'Are conversions unlimited?',
      answer: 'Yes. The current StatementSync plans include unlimited supported bank statement or transaction conversions. Device access and billing differ by plan.',
    },
    {
      question: 'Does StatementSync replace accounting or bookkeeping software?',
      answer: 'No. StatementSync prepares cleaner transaction data from bank statement PDFs. It is intended to support review, reconciliation preparation, analysis and import workflows rather than replace accounting software.',
    },
    {
      question: 'Is StatementSync suitable for Australian bank statements?',
      answer: 'Yes. StatementSync has been designed with Australian banking, bookkeeping and small-business workflows in mind, while support still depends on the readability and structure of each PDF.',
    },
    {
      question: 'How do the Monthly, Annual and Lifetime plans differ?',
      answer: 'Monthly currently includes 1-device access, Annual includes 2-device access, and Lifetime includes 3-device access. Lifetime is a one-time purchase and the Lifetime allocation is capped at 50 licences, with current availability shown on the pricing card.',
    },
    {
      question: 'What happens after checkout?',
      answer: 'After checkout, the purchase flow provides your licence details so you can activate StatementSync with your licence key. Existing licence holders can use the existing-user link on the landing page.',
    },
  ],
};